export default {
	i18n: require('./i18n').default,
	props: ['data', 'index', 'version', 'userData'],
};
